exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3iZkw{position:relative;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;background:#fff;padding:5px 10px 0}._3iZkw,.K5rV-{display:-webkit-box;display:-ms-flexbox;display:flex}.K5rV-{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:10px 15px 0}._3yv6M{position:relative;display:block;text-align:center}._1uDlt{margin:0;font-size:13px;font-weight:400}._1X_UO{width:48px;max-width:40px;max-height:40px;overflow:hidden;color:transparent;margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"root": "_3iZkw",
	"serviceItem": "K5rV-",
	"info": "_3yv6M",
	"title": "_1uDlt",
	"icon": "_1X_UO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/DealerServices/DealerServices.css
// module id = 3091
// module chunks = 17